import React from "react";
import { EmptyState } from "../components";
import { labelForScreen } from "../shell/nav";

// Shown for a nav item whose screen has not been built yet. Deliberately explicit:
// silently falling back to another screen is how v1 ended up with a "View all
// notifications" link that quietly opened the organization list.
const Placeholder = ({ screenKey }) => (
  <div className="v2-page">
    <EmptyState title={`${labelForScreen(screenKey)} is not built yet`}>
      This screen is part of a later pass. Switch to the previous interface from the top
      bar if you need it today.
    </EmptyState>
  </div>
);

export default Placeholder;
